import { styled } from '@mui/system';
import { Box, Paper, AppBar, Tabs, Tab, Button, Divider as MuiDivider, Grid } from '@mui/material';

export const DashboardWrapper = styled('section')(({ theme }) => ({
  height: 'calc(100% - 88px)',
  margin: theme.spacing(3),
  paddingTop: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(4)
  }
}));

export const DashboardCnt = styled(Box)({
  display: 'block',
  height: '100%'
});

export const TabContentCnt = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'start',
  padding: 0,
  height: 'calc(100% - 48px)',
  borderBottomLeftRadius: theme.spacing(),
  borderBottomRightRadius: theme.spacing()
}));

export const MapCnt = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '70%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '100%'
  },
  [theme.breakpoints.up('sm')]: {
    width: '60%'
  },
  [theme.breakpoints.up('md')]: {
    width: '70%'
  },
  '& .mapPreloader': {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    margin: 'auto',
    transform: 'translateY(-50%)'
  },
  '& h4': {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    margin: 'auto',
    transform: 'translateY(-50%)'
  }
}));

export const ShipmentTabs = styled(Box)({
  position: 'relative',
  height: 'calc(100% - 24px)'
});

export const TabsGrid = styled(Grid)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column'
});

export const TabCnt = styled(Box)({
  position: 'relative'
});

export const TabBar = styled(AppBar)(({ theme }) => ({
  display: 'flex',
  backgroundColor: '#FFF !important',
  width: '30%',
  [theme.breakpoints.down('md')]: {
    width: '100%'
  },
  borderTopLeftRadius: theme.spacing(),
  borderTopRightRadius: theme.spacing()
}));

export const TabsRoot = styled(Tabs)({
  '& .MuiTabs-centered': {
    padding: '0 8px',
    overflow: 'hidden'
  }
});

export const StyledTab = styled(Tab)(({ theme }) => ({
  minWidth: '33% !important',
  borderBottom: 0,
  display: 'flex',
  flexDirection: 'row',
  '& > span:nth-of-type(2)': {
    borderLeft: 0,
    borderRight: 0
  },
  '& span': {
    marginLeft: theme.spacing(),
    transform: 'translateY(1px)',
    height: 13
  },
  '&.tabEmpty': {
    opacity: '0.5 !important'
  }
}));

export const BtnCnt = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: -16,
  right: 0,
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    top: -44
  }
}));

export const DialogAppBar = styled(AppBar)({
  position: 'fixed',
  backgroundColor: 'black',
  color: 'white',
  textTransform: 'uppercase'
});

export const CloseIcon = styled(Box)({
  position: 'absolute',
  right: 0,
  color: '#FFF'
});

export const AddBtn = styled(Button)({
  justifySelf: 'end'
});

export const AddButtonLabel = styled('span')({
  color: 'rgba(0, 0, 0, 0.87)',
  marginLeft: 4,
  marginTop: 2,
  whiteSpace: 'nowrap'
});

export const StyledDivider = styled(MuiDivider)(({ theme }) => ({
  marginTop: -1,
  [theme.breakpoints.up('sm')]: {
    width: '40%'
  },
  [theme.breakpoints.up('md')]: {
    width: '30%'
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
}));
